export default __webpack_public_path__ + "static/media/Screen-Icon.48f4b1eb.svg";